import React from "react";
import { connect } from "react-redux";
import { DashboardHeader } from "../../../components/Header";
import Balances from "../../../components/Wallet/balance/Balances";
import language from "../../../language";

class BalanceScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={language[this.props.defaultLanguage].balances}
            titleClassName="text-primary"
          />
          <Balances />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(BalanceScreen);
